import React, {useEffect} from "react";
import styled from "styled-components";
import {useLocation, useParams} from "react-router-dom";

function ExternalContainer() {
    const location = useLocation();

    return <IFrameSC src={(location.state as {link: string})?.link}>
    </IFrameSC>
}

const IFrameSC = styled.iframe`
    height: 100%;
    border: none;
`;

export default ExternalContainer;
